import { Component, ViewEncapsulation } from '@angular/core';
import { IComboBase } from '../../../interfaces/base/base.interface';
import { getYearOptions, monthOptions } from '../../../utils/helpers';
import { CompanyService } from '../../../services/company.service';
import { EmployeeLocalService } from '../../services/employee.service';
import { Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { ModalRejectComponent } from '../../../shared/modals/modal-reject/modal-reject.component';
import { FormControl } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { debounceTime, distinctUntilChanged, map } from 'rxjs';

@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.scss'],
  // encapsulation: ViewEncapsulation.None,
})
export class EmployeeComponent {
  dataSource: any[] = [];
  mostrar: boolean = false;
  dataToEdit: any = null;
  mostrarModalEditar: boolean = false;
  mostrarModalDetalle: boolean = false;
  mostrarModalDocuments: boolean = false;
  mostrarModalBulkLoad: boolean = false;
  dataDetail: any = null;
  originalData: any[] = [];

  viewDeleted: boolean = false;
  employeeId: number = 0;

  searchControl = new FormControl('');

  isLoading: boolean = true;
  pageIndex: number = 0;
  pageSize: number = 10;
  totalElements: number = 0;
  
  searchTerm = '';
  userData: any = null;

  headerClasses: { [key: string]: string } = {
    '1': 'header-keola',
    '2': 'header-inresort',
    '3': 'header-inclub',
    '4': 'header-ribera',
    '5': 'header-keolafood',
    '6': 'header-valle',
  };

  currentHeaderClass: string = 'header-keola';

  constructor(
    private employeeLocalService: EmployeeLocalService,
    private companyService: CompanyService,
    private dialogService: DialogService,
    private router: Router
  ) {
    this.updateDisplayedColumns();
  }

  tabs: IComboBase[] = [];
  selectedTabKey: string | null = null;

  readonly  displayedColumns = [
    { key: 'lastNames', header: 'Apellidos' },
    { key: 'names', header: 'Nombres' },
    { key: 'employeeDocumentNumber', header: 'DNI' },
    { key: 'cityName', header: 'Ciudad' },
    { key: 'countryName', header: 'País' },
    { key: 'startDate', header: 'Fecha de Ingreso'},
    { key: 'phoneEmergency', header: 'Cont. de emer.' },
    { key: 'email', header: 'Correo' },
  ];

  displayedColumnsToShow: { key: string; header: string }[] = [];

  actionButtons = [
    {
      icon: 'pi pi-eye',
      color: '#ED672A',
      tooltip: 'Ver',
      action: (row: any) => {
        this.dataDetail = {
          ...row,
          empresa: this.tabs.find((tab) => tab.key === this.selectedTabKey),
        };
        this.mostrarModalDetalle = true;
      },
      visible: (row: any) => true,
    },
    {
      icon: 'pi pi-pen-to-square',
      color: '#ED672A',
      tooltip: 'Editar',
      action: (row: any) => {
        this.dataToEdit = {
          ...row,
          empresa: this.tabs.find((tab) => tab.key === this.selectedTabKey),
        };
        this.mostrarModalEditar = true;
      },
      visible: (row: any) => true,
    },
    {
      icon: 'pi pi-trash',
      color: '#ED672A',
      tooltip: 'Eliminar',
      action: (row: any) => {
        this.employeeId = row.solicitudId;
        this.viewDeleted = true;
      },
      visible: (row: any) => true,
    },
    {
      icon: 'pi pi-folder',
      color: '#ED672A',
      tooltip: 'Archivos',
      action: (row: any) => {
        this.dataDetail = {
          ...row,
          empresa: this.tabs.find((tab) => tab.key === this.selectedTabKey),
        };
        this.router.navigate([
          `/dashboard/employee/documents/${this.dataDetail.employeeId}`,
        ]);
        this.mostrarModalDocuments = true;
      },
      visible: (row: any) => true,
    },
    
    {
      icon: 'pi pi-info-circle',
      color: '#f59e0b',
      tooltip: (row: any) =>
        row.missingInfoSummary || 'Falta información obligatoria',
      action: (row: any) => {
        this.openTooltipModal(
          'Información pendiente',
          row.missingInfoSummary ||
            'Falta completar información obligatoria del empleado.'
        );
      },
      visible: (row: any) => !!row.hasMissingRequiredInfo,
    },
    {
      icon: 'pi pi-exclamation-triangle',
      color: 'red',
      tooltip: 'Alerta',
      action: (row: any) => {
        this.openTooltipModal(
          'Renovación de contrato',
          `El usuario tiene como fecha de fin de contrato el día ${row.endDate}, revisar su renovación.`
        );
      },
      visible: (row: any) =>
        this.isEndDateWithinOneMonth(row.endDate) &&
        row.stateLastContractId == 3,
    },
  ];

  ngOnInit(): void {
    const userDataString = localStorage.getItem('access');
    if (userDataString) this.userData = JSON.parse(userDataString);

    this.searchControl.valueChanges
    .pipe(
      debounceTime(300),
      map((value) => (value ?? '').trim()),
      distinctUntilChanged()
    )
    .subscribe((search) => {
      this.searchTerm = search;
      this.filterData(true);
    });

    this.companyService.comboCompany().subscribe({
      next: (data) => {
        this.tabs = data;
        this.selectedTabKey = this.tabs[0].key;
        this.onTabSelected(this.selectedTabKey);
      },
      error: (err) => {
        console.error('Error al obtener la lista de empresas:', err);
        this.filterData();
      },
    });
  }

  onNewRegister(): void {
    this.router.navigate(['/dashboard/employee/list/register']);
  }

  onBulkLoad(): void {
    this.mostrarModalBulkLoad = true;
  }

  onExport(): void {
    console.log('Implementar función de exportar data');
  }

  onDialogClose() {
    this.mostrar = false;
  }

  onDialogDetailClose() {
    this.mostrarModalDetalle = false;
    this.dataDetail = null;
  }

  updateDisplayedColumns(): void {
    this.displayedColumnsToShow = this.displayedColumns;
  }

  isWithinOneMonth(endDateString: string): boolean {
    if (!endDateString) return false;

    try {
      const [day, month, year] = endDateString.split('/').map(Number);
      const endDate = new Date(year, month - 1, day);
      const today = new Date();
      const oneMonthFromNow = new Date(today);
      oneMonthFromNow.setMonth(today.getMonth() + 1);

      return endDate >= today && endDate <= oneMonthFromNow;
    } catch (e) {
      console.error('Error parsing date:', endDateString, e);
      return false;
    }
  }

  openTooltipModal(title: string, description: string) {
    this.dialogService.open(ModalRejectComponent, {
      closable: false,
      data: {
        title: title,
        text: description,
        icon: 'pi pi-exclamation-triangle',
        showButton: true,
      },
    });
  }

  onSearch(query: string): void {
    this.searchControl.setValue(query);
  }

  isEndDateWithinOneMonth(endDate: string): boolean {
    if (!endDate) return false;

    const [day, month, year] = endDate.split('/').map(Number);
    const end = new Date(year, month - 1, day);
    const today = new Date();
    const oneMonthFromNow = new Date(today);
    oneMonthFromNow.setMonth(today.getMonth() + 1);
    return end >= today && end <= oneMonthFromNow;
  }

  filterData(resetPage: boolean = false): void {
    if (resetPage) {
      this.pageIndex = 0;
    }

    this.isLoading = true;

    const filters = {
      search: this.searchTerm || null,
      companyId: this.selectedTabKey || null,
      employeeState: true,
      page: this.pageIndex,
      size: this.pageSize,
    };

    this.employeeLocalService.postEmployeeByCompany(filters).subscribe({
      next: (response) => {
        this.dataSource = response.content;
        this.pageIndex = response.page.page;
        this.pageSize = response.page.size;
        this.totalElements = response.page.totalElements;
        this.isLoading = false;
      },
      error: (err: any) => {
        this.isLoading = false;
        console.error('Error al obtener los datos:', err);
      },
    });
  }

  applyLocalFilters(): void {
    this.dataSource = this.originalData ? [...this.originalData] : [];
  }

  onTabSelected(tabKey: string): void {
    this.selectedTabKey = tabKey;
    this.currentHeaderClass = this.headerClasses[tabKey] || 'header-keola';
    this.filterData(true);
  }

  onPageChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.filterData();
  }

  onRowSelected(row: any): void {}

  onRegisterComplete(): void {
    this.filterData();
  }

  onEditComplete(): void {
    this.filterData();
  }

  onBulkLoadComplete(): void {
    this.mostrarModalBulkLoad = false;
    this.filterData(true);
  }

  onDeleteComplete(): void {
    this.filterData();
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';

    // Mapeo de nombres de meses en inglés a números
    const monthsMap: { [key: string]: string } = {
      January: '01',
      February: '02',
      March: '03',
      April: '04',
      May: '05',
      June: '06',
      July: '07',
      August: '08',
      September: '09',
      October: '10',
      November: '11',
      December: '12',
    };

    // Extraer los datos de la fecha usando una expresión regular
    const dateParts = dateString.match(/(\w+)\s(\d+)\sdel\s(\d+)/);
    if (!dateParts) return dateString;

    const month = monthsMap[dateParts[1]];
    const day = dateParts[2].padStart(2, '0');
    const year = dateParts[3].slice(-2);

    return `${day}/${month}/${year}`;
  }
}
